import PropTypes from 'prop-types';
import React from 'react';
import ReactCollapse from 'react-collapse';
import { values } from 'lodash';

import { LocaleService } from '@sm360/widget-commons-core-services';
import { PurchaseMethods, Vehicle } from '@sm360/widget-commons-vehicle';

import './TileDisclaimer.scss';

const { VehicleDisclaimersContent } = Vehicle;
const { PurchaseMethodsModel } = PurchaseMethods;

const FINANCE_TYPE = {
    FINANCE: 'finance',
    LEASE: 'lease',
    CASH: 'cashPurchase',
};

class TileDisclaimer extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isDisclaimerOpen: false,
        };

        this.handleButtonClick = this.handleButtonClick.bind(this);
    }

    handleButtonClick(e) {
        e.stopPropagation();
        this.setState({ isDisclaimerOpen: !this.state.isDisclaimerOpen });
    }

    render() {
        const { czDisclaimer, vehiclePurchaseMethod, currentFinanceType } = this.props;
        if (!czDisclaimer && !vehiclePurchaseMethod) {
            return null;
        }

        const disclaimertextButton = this.state.isDisclaimerOpen
            ? LocaleService.t('VEHICLE_TILE_DISCLAIMER.HIDE')
            : LocaleService.t('VEHICLE_TILE_DISCLAIMER.OPEN');

        return (
            <div className="listing-tile-note">
                <button className="sr-link" onClick={this.handleButtonClick}>
                    {disclaimertextButton}
                </button>
                <div className="vehicle-note__wrapper">
                    <ReactCollapse
                        isOpened={this.state.isDisclaimerOpen}
                        springConfig={{ stiffness: 270, damping: 30 }}
                    >
                        <span className="vehicle-note">
                            <VehicleDisclaimersContent
                                disclaimers={
                                    vehiclePurchaseMethod && vehiclePurchaseMethod.disclaimers[currentFinanceType]
                                }
                                disclaimersContentZone={czDisclaimer}
                            />
                        </span>
                    </ReactCollapse>
                </div>
            </div>
        );
    }
}

TileDisclaimer.defaultProps = {
    czDisclaimer: '',
    vehiclePurchaseMethod: null,
};

TileDisclaimer.propTypes = {
    czDisclaimer: PropTypes.string,
    vehiclePurchaseMethod: PropTypes.instanceOf(PurchaseMethodsModel),
    currentFinanceType: PropTypes.oneOf(values(FINANCE_TYPE)).isRequired,
};

TileDisclaimer.displayName = 'TileDisclaimer';
TileDisclaimer.FINANCE_TYPE = FINANCE_TYPE;

export { FINANCE_TYPE };

export default TileDisclaimer;



// WEBPACK FOOTER //
// ./src/components/TileDisclaimer/TileDisclaimer.jsx